(function ($) {

    this.init = function () {

        // defer any measurements until the doc is finished loading
        setTimeout(function () {
            var windowHeight, documentHeight, $floattingArrowButton, $floatingArrowRegion;

            windowHeight = $(window).height();
            documentHeight = $(document).height();
            $floatingArrowRegion = $(".floatingarrow");
            $floattingArrowButton = $(".floatingarrow-button");

            if (typeof windowHeight !== "number" || typeof documentHeight !== "number" || documentHeight < (2 * windowHeight)) {
                $floatingArrowRegion.remove();
            } else {
                $floatingArrowRegion.css("visibility","visible");
                if (document.documentElement.scrollTop < (documentHeight - windowHeight - 100)) {
                    // make sure the button is the correct direction
                    $("#ScrollDownButton").show();
                    $("#ScrollUpButton").hide();
                } else {
                    $("#ScrollDownButton").hide();
                    $("#ScrollUpButton").show();
                }

                $floattingArrowButton.on("click", function () {
                    if ($(this).attr("id") === "ScrollUpButton") {
                        // scroll up the page
                        $('html, body').animate({
                            scrollTop: 0
                        }, 800);
                    } else {
                        // Scroll down the page
                        $('html, body').animate({
                            scrollTop: $(window).scrollTop() + windowHeight
                        }, 800);
                    }
                });
                $(window).on("scroll", function () {
                    if (document.documentElement.scrollTop < (documentHeight - windowHeight)) {
                        // make sure the button is the correct direction
                        $("#ScrollDownButton").show();
                        $("#ScrollUpButton").hide();
                    } else {
                        $("#ScrollDownButton").hide();
                        $("#ScrollUpButton").show();
                    }
                });
            }
        }, 0);
    };


    this.init();

})(jQuery);